import { useContext } from "react";
import { LogContext } from "./log.context";

export const useLogging = () => {
  return useContext(LogContext);
};
